import src from "IMAGE";
export default { src, width: 155, height: 46, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AAIGExoFDyw+AwgZJQUNJTwFDSZBBQ0mQgQMIjUBAwoRAAMHFSEHFT1dBxQ7WwUQLUkGEC5PBhEyVwMJGywAAQIE0J4GqN5vSf8AAAAASUVORK5CYII="};
